import { useEffect } from "react";
import { useLocation } from "react-router";
import { Room } from "twilio-video";

type Props = {
  getAudioAndVideoTracks: () => Promise<void>;
  room: Room | null;
  removeLocalAudioTrack: () => void;
  removeLocalVideoTrack: () => void;
};

export const useAudioAndVideoLocalTracks = ({
  getAudioAndVideoTracks,
  room,
  removeLocalAudioTrack,
  removeLocalVideoTrack,
}: Props) => {
  const location = useLocation();

  useEffect(() => {
    const isLiveMeetingPath = location.pathname.includes("/meeting/live/");
    const isLiveVotingPath = location.pathname.includes("/voting/live/");

    if (isLiveMeetingPath || isLiveVotingPath) {
      getAudioAndVideoTracks();
    } else {
      room?.localParticipant.tracks.forEach((publication) => {
        if (
          publication.track.kind === "audio" ||
          publication.track.kind === "video"
        ) {
          publication.track.stop();
          const attachedElements = publication.track.detach();
          attachedElements.forEach((element) => element.remove());
        }
      });
      room?.disconnect();
      removeLocalAudioTrack();
      removeLocalVideoTrack();
    }
  }, [
    location,
    getAudioAndVideoTracks,
    room,
    removeLocalAudioTrack,
    removeLocalVideoTrack,
  ]);
};
